import { render, staticRenderFns } from "./SellerLanding.vue?vue&type=template&id=4aed0615&"
import script from "./SellerLanding.vue?vue&type=script&lang=js&"
export * from "./SellerLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports